const CONFIG = {
  MODEL_IMAGE: 'icons/model-icon.png',
  LONG_DATE_FORMAT: 'YYYY-MM-DDTHH:mm:ss.SSSSSZ',
};

export const LS_KEY = {
  ISP: 'new_isp',
  DATA_PREPARE: 'data_prep',
  DATA_DETECTION: 'data_detection',
  DATA_SEGMENTATION: 'data_segmentation',
  CONFIG: 'config',
};

const GENERAL_DESCRIPTIONS_SETTINGS = {
  maxLength: 450,
  multiline: true,
  className: 'studio__input-field-description',
};

export const PROJECT_SETTINGS = {
  name: {
    maxLength: 32,
  },
  description: GENERAL_DESCRIPTIONS_SETTINGS,
};

export const ISP_SETTINGS = {
  name: {
    maxLength: 32,
  },
  description: GENERAL_DESCRIPTIONS_SETTINGS,
};

export const PRE_AND_POST_PROCESSORS_SETTINGS = {
  name: {
    maxLength: 32,
  },
  description: GENERAL_DESCRIPTIONS_SETTINGS,
};

export const PRE_AND_POST_PROCESSORS_PARAMETERS_SETTINGS = {
  description: GENERAL_DESCRIPTIONS_SETTINGS,
};

export const TEST_PANEL_SETTINGS = {
  name: {
    maxLength: 32,
  },
  description: GENERAL_DESCRIPTIONS_SETTINGS,
};

export const DEPLOY_PANEL_SETTINGS = {
  name: {
    maxLength: 32,
  },
  description: GENERAL_DESCRIPTIONS_SETTINGS,
};

export const ACCEPTED_FILE_TYPES = [
  '.jpg',
  '.jpeg',
  '.jpe',
  '.jif',
  '.jfif',
  '.jfi',
  '.png',
  '.gif',
  '.webp',
  '.tiff',
  '.tif',
  '.psd',
  '.raw',
  '.arw',
  '.cr2',
  '.nrw',
  '.k25',
  '.bmp',
  '.dib',
  '.heif',
  '.heic',
  '.ind',
  '.indd',
  '.indt',
  '.jp2',
  '.j2k',
  '.jpf',
  '.jpx',
  '.jpm',
  '.mj2',
  '.svg',
  '.svgz',
  '.ai',
  '.eps',
  '.y',
];

export const REQUEST_POLLING_INTERVAL = 5000;

export default CONFIG;
